import { render } from "./vcurriculumorder.vue?vue&type=template&id=cc61340a&scoped=true"
import script from "./vcurriculumorder.vue?vue&type=script&lang=js"
export * from "./vcurriculumorder.vue?vue&type=script&lang=js"

import "./vcurriculumorder.vue?vue&type=style&index=0&id=cc61340a&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc61340a"]])

export default __exports__